export const validatePageNumber = (page, pageCount) => {
    if (page && !(page <= 0) && !(page > pageCount)) {
        return true;
    }
    return false;
};
